import React from "react";
import VisitChild from "./VisitChild";
import WebService from "api/explus-api";

class VisitChildContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            childrenList: [],
            selectedChild: "None selected",
            data: {
                child_id: "",
                visitDate: "",
                visitTime: "",
                meetChildWith: [],
                withGift: false,
                typeOfGift: "",
                sponsorCompanions: "",
                activities: [],
                other: "",
                agreeToShoulderExpenses: false,
                agreeToWorldvisionPolicy: false
            },
            loading: false
        };

        this.getChildren = this.getChildren.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.listChildren = this.listChildren.bind(this);
        this.getDatePickerValue = this.getDatePickerValue.bind(this);
        this.getInputValue = this.getInputValue.bind(this);
    }

    componentWillMount() {
        this.getChildren();
    }

    getChildren() {
        let items = [];
        let state = "childrenList";

        if (sessionStorage.getItem(state)) {
            // console.log(state)
            items = sessionStorage.getItem(state);

            // set cached data if it is available
            this.setState({ [state]: JSON.parse(items) });
        } else {
            WebService.ajaxGet("/explus/web/childrenmenu").then(data => {
                if (data.status === "error") {
                    return "error";
                }

                this.initialSelectedChild(data);

                this.setState({ [state]: data });
            });
        }
    }

    initialSelectedChild(data) {
        if (!data) return;

        const childId = this.props.match.params.childId;
        const childrenList = data;

        if (childId && childrenList.length > 0) {
            const selectedChild = childrenList.filter(list => {
                return list.child_id === childId;
            });

            if (selectedChild[0] !== undefined) {
                this.setState(prevState => ({
                    data: {
                        ...prevState.data,
                        child_id: selectedChild[0].child_id
                    }
                }));

                this.setState({ selectedChild: selectedChild[0].name });
            }
        }
    }

    listChildren() {
        return this.state.childrenList.map((child, index) => {
            return (
                <li key={index}>
                    <a href="#selectchild" onClick={this.handleClick(child)}>
                        {child.name}
                    </a>
                </li>
            );
        });
    }

    handleClick(value) {
        if (!value) {
            return;
        }

        return e => {
            e.preventDefault();

            this.setState(prevState => ({
                data: { ...prevState.data, child_id: value.child_id }
            }));

            this.setState({ selectedChild: value.name });
        };
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({ loading: true });
        WebService.sponVisit(this.state.data).then(() => {
            this.setState({ loading: false });
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (target.type === "checkbox") {
            if (this.selectedCheckboxes.has(value)) {
                this.selectedCheckboxes.delete(value);
            } else {
                this.selectedCheckboxes.add(value);
            }

            this.setState(prevState => ({
                data: { ...prevState.data, [name]: this.selectedCheckboxes }
            }));
        } else {
            this.setState(prevState => ({
                data: { ...prevState.data, [name]: value }
            }));
        }
    }

    getInputValue(name, value) {
        this.setState(prevState => ({
            data: { ...prevState.data, [name]: value }
        }));
    }

    getDatePickerValue(value) {
        this.setState(prevState => ({
            data: { ...prevState.data, visitDate: value }
        }));
    }

    render() {
        return (
            <VisitChild
                loading={this.state.loading}
                values={this.state.data}
                postData={this.state.data}
                change={this.handleChange}
                getInputValue={this.getInputValue}
                submit={this.handleSubmit}
                listChildren={this.listChildren}
                selectedChild={this.state.selectedChild}
                getDatePickerValue={this.getDatePickerValue}
            />
        );
    }
}

export default VisitChildContainer;
